import React, {useEffect} from 'react'
import {connect} from "react-redux";
import { Button } from 'antd';
import {FormattedMessage} from "react-intl";
import {goToLoginForm} from '@actions/userActions';
import {loginUser, setUser, loadUser} from '@actions/userActions';

function Login({goToLoginForm, user, loadUser}) {

    useEffect(() => {
        if (!user) {
          loadUser();
        }
      }, [])

    return (
        ''
    )
}

function mapStateToProps(state) {
    return {
        user: state.user
    }
}

const mapDispatchToProps = {
    goToLoginForm,
    loadUser
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);